import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { ErrorBoundary } from "./hoc/ErrorBoundary";
import Routes from "./routes";
import { store } from "./store/store";
import LogRocket from "logrocket";
import { useEffect } from "react";
import { getUserFromStorage } from "./util/localStorage.util";
import { isUserLoggedIn } from "./util/auth.util";

function App() {
  const isLoggedIn = isUserLoggedIn();
  useEffect(() => {
    LogRocket.init("lyavan/meyco");
  }, []);
  useEffect(() => {
    if (isLoggedIn) {
      const userString = getUserFromStorage();
      const { data: user } = !!userString ? JSON.parse(userString) : null;
      if (!!user) {
        console.log("identify ran: ", user);
        LogRocket.identify(user.userId, {
          name: user.userName,
          email: user.email,
        });
      }
    }
  }, [isLoggedIn]);
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <Provider store={store}>
          <Routes />
        </Provider>
      </ErrorBoundary>
    </BrowserRouter>
  );
}

export default App;
